import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'limit'
})
export class LimitPipe implements PipeTransform {

    transform(value: Array<string>, limitsize: number): any {
        if (limitsize === 0) {
            return value;
        }
        return value.slice(0, limitsize);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/limit.pipe.ts